import { Component } from '@angular/core';
import { MapState } from '../../state/map-state';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { IAppState } from '../../../../app_state';

const placeholders = {
  storeName: '{store_name}',
  postmamStoreName: '{{store.name}}',
  product: '{product}'
};

@Component({
  selector: 'yi-map-preview',
  template: require('./map_preview.component.html'),
  styles: [ require('../../../install.utils.scss'), require('./map_preview.component.scss')]
})
export class MapPreviewComponent {
  mapState$ = this.state.select(state => state.app.install.map);

  constructor(private state: Store<IAppState>) {}

  public getSubject() {
    return this.state.select(state => state.app.install.map).pipe(map((mapState: MapState) => {
      return mapState.hasPostmanDeliveryFeature ? mapState.subject.replace(placeholders.postmamStoreName, mapState.storeName)
        : mapState.subject.replace(placeholders.storeName, mapState.storeName);
    }));
  }

}
